import React, { useState, } from 'react'
import { Avatar, Typography, Card, CardContent, CardHeader, Chip } from '@material-ui/core'
import { Col, FormGroup, Input, Row } from 'reactstrap'
import PlusMinusButton from './Shop/PlusMinusButton'
import { green } from '@material-ui/core/colors';
function ExtraProduct({ product, onChange, showCard }) {
  const [amount, setAmount] = useState(0)
  const [sum, setSum] = useState(0)
  const [active, setActive] = useState(false)

  const updateAmount = (value) => {
    setAmount(value)
    setSum(value * product.price)
    setActive(value > 0)
    onChange(product.id, value)
  }

const selectionStyle = active ? { background: 'white', borderColor: '#9ecaed', boxShadow: 'inset 0 0 10px #9ecaed' } : {}

  if (showCard) {
    return (
      <Card className={'mb-2'} key={product.id || Math.random().toString()} style={{...selectionStyle, cursor: 'pointer'  }}>
        <CardHeader title={product.displayName} disableTypography={true} style={{ paddingBottom: 0 }} />
        <CardContent style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingBottom: 5, paddingTop: 10 }}>
          {product.image && product.image.length > 0 ? (
            <Avatar variant='square' className='item-image' src={product.image} alt='' />) : (
            null
          )}
          <Row>
            <Col>
              <Chip label={(product.price / 100).toFixed(2).replace('.', ',') + ' € / kpl'} style={{ backgroundColor: green[500], color: 'white' }} size='small' />
            </Col>
          </Row>
          <Row style={{ marginTop: 5, display: 'flex', alignItems: 'center' }}>
            <Col>
              <PlusMinusButton onChange={updateAmount} max={product.amounts ? Math.max(...product.amounts) : undefined} loading={false} />
             </Col>
          </Row>
        </CardContent>
      </Card>
    )
  } else {
    return (
      <Row key={product.id || Math.random().toString()}>
      
        <Col xs={2} sm={1}>
          {product.image && product.image.length > 0 ? (
            <Avatar variant='square' className='item-image' src={product.image} alt='' />) : (
            null
          )}
        </Col>
        <Col xs={6} sm={9}>
          <Typography variant='body2' className='item-name'>
            {product.displayName} {(product.price / 100).toFixed(2).replace('.', ',') + ' € / kpl'}
          </Typography>
          <Typography variant='caption' className='item-description'>
            {product.desc}
          </Typography>
        </Col>
        <Col xs={4} sm={2}>
          <FormGroup className='loose-form'>
            <Input
              type='select'
              name='select'
              id='itemSelect'
              value={amount || 0}
              onChange={(e) => updateAmount(e.target.value)}
            >
              <option value={0}></option>
              {product.amounts.map((a, i) => (
                <option value={a} key={'ep-' + i}>{a}</option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>
    )
  }
}

export default ExtraProduct
